import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GET_LOCATIONS, CREATE_TOURGUIDE, EDIT_TOURGUIDE, GET_MY_TOURGUIDE_PROFILE, GET_PRESIGNED_IMAGE_URLS } from "../../redux/api/constants";
import { clearPresignedImages, doFetch, doPost, doPut, localEditTourguide, s3upload } from "../../redux/api/actions";
import { useNavigate, Link } from "react-router-dom";
import TourGuideForm from "./tourguideProfileForm";
import Layout from "../layout";
import { useTranslation } from "react-i18next";

const TourGuideEdit = () => {
    const { t } = useTranslation();
    const me = useSelector(state => state.API.me);
    const locations = useSelector(state => state.API.locations);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const accessToken = useSelector(state => state.Auth.accessToken);
    const tourguide = useSelector(state => state.API.tourguide);
    const presignedProfileImageUrls = useSelector(state => state.API.presignedImageUrls);
    const [files, setFiles] = useState([]);

    useEffect(() => {
        dispatch(doFetch(GET_LOCATIONS, "locations"))
    }, [dispatch])

    useEffect(() => {
        dispatch(doFetch(GET_MY_TOURGUIDE_PROFILE, "tourguide/me", accessToken))
    }, [dispatch, accessToken]);

    const submitForm = (params) => {
        if (presignedProfileImageUrls && presignedProfileImageUrls.length > 0) {
            const processedImageUrls = presignedProfileImageUrls.map(url => url.split("?")[0])
            params.avatar_url = processedImageUrls[0]
        }

        if (tourguide?.id) {
            dispatch(doPut(
                EDIT_TOURGUIDE,
                "tourguide",
                accessToken,
                { ...tourguide, ...params },
                navigate
            ))
        } else {
            dispatch(doPost(
                CREATE_TOURGUIDE,
                "tourguide",
                accessToken,
                params,
                navigate
            ))
        }
        dispatch(clearPresignedImages())
    }

    useEffect(() => {
        if (presignedProfileImageUrls && presignedProfileImageUrls.length > 0 && files.length > 0) {
            dispatch(s3upload(files, presignedProfileImageUrls));
            const processedImageUrls = presignedProfileImageUrls.map(url => url.split("?")[0])
            if (tourguide) {
                tourguide.avatar_url = processedImageUrls[0]
                dispatch(localEditTourguide(tourguide))
            } else {
                const newTourguide = { avatar_url: processedImageUrls[0] }
                dispatch(localEditTourguide(newTourguide))
            }
        }
    }, [presignedProfileImageUrls, files, dispatch, tourguide])

    const imageUploadFunc = (passedFiles) => {
        const fileNames = Array.from(passedFiles).map((f) => f.name);
        dispatch(doPost(
            GET_PRESIGNED_IMAGE_URLS,
            "tourguide/presigned-urls",
            accessToken,
            { "images": fileNames }
        ))
        setFiles(passedFiles)
    }

    return (
        <Layout selected="tourguide">
            <div className="tour-editor">
                <nav aria-label="breadcrumb" className="breadcrumb-nav">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
	                            <Link to="/">{t('home')}</Link>
	                        </li>
	                        <li className="breadcrumb-item">
	                            <Link to="/tourguide#tab1">{t('dashboard')}</Link>
	                        </li>
	                        <li className="breadcrumb-item active">{t('guide-edit-profile')}</li>
                    </ol>
                </nav>

                <div className="editor-header">
	                    <h1>{tourguide ? t('guide-edit-your-profile') : t('guide-create-profile')}</h1>
	                    <p className="subtitle">
	                        {tourguide 
	                            ? t('guide-update-info-subtitle') 
	                            : t('guide-create-info-subtitle')
	                        }
                    </p>
                </div>

                <TourGuideForm
                    me={me}
                    formSubmitFunc={submitForm}
                    locations={locations}
                    tourguide={tourguide}
                    imageUploadFunc={imageUploadFunc}
                />
            </div>
        </Layout>
    )
}

export default TourGuideEdit;
